import {
    LEADER_BOARD_GET_SETTINGS,
    LEADER_BOARD_GET_SETTINGS_SUCCESS,
    LEADER_BOARD_PUT_SETTINGS,
    LEADER_BOARD_PUT_SETTINGS_SUCCESS,
    LEADER_BOARD_SETTINGS_QUIZ,
    LEADER_BOARD_SETTINGS_QUIZ_SUCCESS,
} from './constants';

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const leaderBoardSettingsQuiz = ( param ) => ( {
    type: LEADER_BOARD_SETTINGS_QUIZ,
    param
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const leaderBoardSettingsQuizSuccess = ( result ) => ( {
    type: LEADER_BOARD_SETTINGS_QUIZ_SUCCESS,
    result
} );


/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const leaderBoardGet = ( id ) => ( {
    type: LEADER_BOARD_GET_SETTINGS,
    id
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const leaderBoardGetSuccess = ( result ) => ( {
    type: LEADER_BOARD_GET_SETTINGS_SUCCESS,
    result
} );

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const leaderBoardPut = ( id, data ) => ( {
    type: LEADER_BOARD_PUT_SETTINGS,
    id,
    data
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const leaderBoardPutSuccess = ( result ) => ( {
    type: LEADER_BOARD_PUT_SETTINGS_SUCCESS,
    result
} );

export {
    leaderBoardGet,
    leaderBoardGetSuccess,
    leaderBoardPut,
    leaderBoardPutSuccess,
    leaderBoardSettingsQuiz,
    leaderBoardSettingsQuizSuccess
};